// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clinicSettings .clinicSettings_row{display:flex;justify-content:center;align-items:center}.clinicSettings .clinicSettings_row>div{margin:5px}.clinicSettings .qr_wrapper{margin-top:20px}.clinicSettings .select_image_wrapper{align-items:center}.clinicSettings .select_image_wrapper>img{max-height:100px;margin-bottom:10px}@media only screen and (max-width: 500px){.clinicSettings_row{flex-direction:column}}\n", ""]);
// Exports
module.exports = exports;
